import { render, staticRenderFns } from "./PermissionCategorySingleSelector.vue?vue&type=template&id=47a4e36a&scoped=true&"
import script from "./PermissionCategorySingleSelector.vue?vue&type=script&lang=js&"
export * from "./PermissionCategorySingleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4e36a",
  null
  
)

export default component.exports